import { IntlShape } from 'react-intl';
import { ResultsSortingTypesEnum } from './types';

export const ResultsSectionQuestions = (intl: IntlShape) => ({
  sort: {
    options: [
      {
        label: intl.formatMessage({ id: 'affordabilityCalculator.results.initialMonthlyRepaymentsAsc' }),
        value: ResultsSortingTypesEnum.initialMonthlyRepaymentsAsc,
      },
      {
        label: intl.formatMessage({ id: 'affordabilityCalculator.results.maxFinancingDesc' }),
        value: ResultsSortingTypesEnum.maxFinancingDesc,
      },
      {
        label: intl.formatMessage({ id: 'affordabilityCalculator.results.initialTermAsc' }),
        value: ResultsSortingTypesEnum.initialTermAsc,
      },
      {
        label: intl.formatMessage({ id: 'affordabilityCalculator.results.initialRateAsc' }),
        value: ResultsSortingTypesEnum.initialRateAsc,
      },
    ],
  },
});
